'use strict'

import AbstractService from '@/app/service/abstract-service'
import StatusResult from '@/app/model/status/status-result'
import StatusTypes from '@/app/model/status/status-types'
import Helper from '@/utils/helper'
import store from '@/store/store'
import { APP } from '@/store/types'

class ApiService extends AbstractService {
  constructor(http, store, pageManager) {
    super()
    this.$http = http
    this.$store = store
    this.$pageManager = pageManager
  }

  async statusReceipt() {
    try {
      const statusRequest = store.state.app.statusRequest
      const {data} = await this.$http.get(`/status?p=${statusRequest.getPointId()}&d=${statusRequest.getSaleId()}&a=${statusRequest.getSaleCode()}`)
      const result = new StatusResult(data)
      const resultState = result.getState()
      switch (resultState) {
        case StatusTypes.IN_PROCESS:
          this.$pageManager.showLoad()
          break
        case StatusTypes.SUCCESS:
          if (Helper.isDefined(result.getSaleInfo())) {
            await store.dispatch(APP.receiptInfo.set, {receiptInfo: result.getSaleInfo()})
            this.$pageManager.showReceipt()
            return
          }
          window.location.replace(result.getReceiptUrl())
          break
        default:
        // skip
      }
    } catch (e) {
      this.$pageManager.showError({
        title: 'Мы не нашли ваш чек :(',
        desc: 'Попробуйте воспользоваться сервисом позднее'
      })
    }
  }
}

export default ApiService
